// components/layout/ThemeToggle.js
import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../hooks/useTheme';

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.2rem;
  transition: all 0.3s ease;

  &:hover {
    color: var(--accent-primary);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 0.75rem;
    font-size: 1.3rem;
    margin-top: 0.5rem;
  }
`;

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <ToggleButton onClick={toggleTheme}>
            {theme === 'light' ? '🌙' : '☀️'}
        </ToggleButton>
    );
};

export default ThemeToggle;
